import { authorizedGet } from 'api'
import { TEACHER_DC } from '../constants'
import { AnyUserData, StatusType, UserType } from 'types'
import { ErrorProp } from './'

export interface RequestProps {
  results: Partial<AnyUserData>[]
  total?: number
  error?: ErrorProp | string | undefined
}
export interface ResponseProps extends Omit<RequestProps, 'error'> {}

export interface JsonResponse extends Partial<RequestProps> {}

export type SearchProps = {
  query?: string
  userType?: UserType
  size?: number
}

export async function search({
  query = '',
  userType,
  size = 5,
}: SearchProps): Promise<ResponseProps> {
  try {
    const endpoint = 'search'
    const params = {
      query,
      size: String(size),
      userType: userType ? userType : undefined,
    }

    const response = await authorizedGet({
      endpoint,
      params,
    })

    const json = await response.json()
    const { total, results, error }: JsonResponse = json

    if (response.ok) {
      let processedResults = results?.map((user) => {
        if (user.status) {
          return user
        } else if (user.userType === TEACHER_DC) {
          return { ...user, status: 'teacher' as StatusType }
        } else {
          return { ...user, status: 'unknown' as StatusType }
        }
      })
      return { results: processedResults ?? [], total }
    } else {
      return Promise.reject(error ?? json.message)
    }
  } catch (e: any) {
    return Promise.reject(e.message)
  }
}
